import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import { HOME } from "@/data/homeContent";

export default function QualificationBlock() {
  const q = HOME.qualification;
  return (
    <section id="qualify" className="bg-ink-950 px-6 py-16 md:py-24" data-testid="home-qualification">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={q.eyebrow} title={q.headline} testId="home-qualification-heading" />
        <div className="mt-10 grid gap-5 md:mt-12 md:grid-cols-2">
          {[q.for, q.notFor].map((col, i) => (
            <Reveal key={col.title} delay={i * 0.1} className="h-full">
              <div
                className={`h-full rounded-lg border p-7 ${
                  i === 0 ? "border-brand/30 bg-ink-900/60" : "border-line bg-ink-900/60"
                }`}
                data-testid={`qualification-${i === 0 ? "for" : "not-for"}`}
              >
                <h3 className={`font-display text-lg font-medium uppercase tracking-[0.08em] ${i === 0 ? "text-brand-light" : "text-silver-mid"}`}>
                  {col.title}
                </h3>
                <ul className="mt-5 space-y-3">
                  {col.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-fg-muted">
                      <span
                        className={`mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 ${i === 0 ? "bg-brand" : "bg-silver-dark"}`}
                        aria-hidden="true"
                      />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}